import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { DeleteRolesDocument } from './delete.generated';

export const useDeleteRoles = (options: ApiOptions<typeof DeleteRolesDocument> = {}) => {
  const { t } = useTranslation();

  return useMutation(DeleteRolesDocument, {
    ...useNotifications(DeleteRolesDocument, {
      failure: (error) => error.message || t('api.common.error_generic'),
      success: (data) => {
        const count = data.deleteRoles?.deletedIds.length ?? 0;
        return t('api.roles.delete_success_plural', { count });
      },
    }),

    update(cache, { data }) {
      data?.deleteRoles?.deletedIds.forEach((id) => {
        cache.evict({ id: cache.identify({ __typename: 'Role', id }) });
      });
    },

    ...options,
  });
};
